







import Vue from "vue";

const App = Vue.extend({
  name: "App",
});

export default App;
